export default __webpack_public_path__ + "static/media/background.1c93ba96.jpg";